import { render, staticRenderFns } from "./ViHomeHeroSearch.vue?vue&type=template&id=178dfeb4&scoped=true"
import script from "./ViHomeHeroSearch.vue?vue&type=script&lang=js"
export * from "./ViHomeHeroSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178dfeb4",
  null
  
)

export default component.exports